// --- Our Modules --------------------------------------------------------------------------------
import usePermission from "@/hooks/usePermission";
import useTranslation from "@/hooks/useTranslation";
import type { TyNavTab, TyNavTabs } from "./types";

// --- Logic --------------------------------------------------------------------------------------

/**
 * The single source of truth for the dashboard's destinations, already filtered to what this admin
 * may open. The sidebar and the mobile tabs bar both read it so a permission change can never show a
 * tab on one surface and hide it on the other.
 */
export default function useNavTabs(): TyNavTabs {
    const t = useTranslation();
    const { canView } = usePermission();

    const mainTabs: TyNavTab[] = [
        { path: "/", label: t.sideBar.home, icon: "home", show: true },
        { path: "/stores", label: t.sideBar.stores, icon: "stores", show: canView("stores") },
        { path: "/subscriptions", label: t.sideBar.subscriptions, icon: "subscription", show: canView("subscriptions") },
        { path: "/support", label: t.sideBar.support, icon: "support", show: canView("support") },
        { path: "/contacts", label: t.sideBar.contacts, icon: "contacts", show: canView("contacts") },
        { path: "/coupons", label: t.sideBar.coupons, icon: "coupons", show: canView("coupons") },
        { path: "/clients", label: t.sideBar.clients, icon: "clients", show: canView("clients") },
        { path: "/logs", label: t.sideBar.logs, icon: "logs", show: canView("logs") },
    ]
        .filter((tab) => tab.show)
        .map(({ path, label, icon }) => ({ path, label, icon }));

    return { mainTabs, allTabs: mainTabs };
}
